import { render, staticRenderFns } from "./farmerInfo.vue?vue&type=template&id=6bdd99e9&scoped=true"
import script from "./farmerInfo.vue?vue&type=script&lang=js"
export * from "./farmerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdd99e9",
  null
  
)

export default component.exports